<template>
  <div class="p-vocational">
    <!--头部-->
    <div class="title kf-animate kf-animate-img">
      <div class="title_text">
        <p>企业应用型人才解决方案提供商</p>
      </div>
    </div>
    <!--内容-->
    <div class="g-box" v-if="list">
      <div
        class="box1"
        v-for="(item, index) in list"
        :key="index"
        :style="index % 2 === 0 ? '' : 'flex-direction: row-reverse;'"
      >
        <div
          class="left_img"
          :style="{ backgroundImage: 'url(' + item.image + ')' }"
        ></div>
        <div class="right_nav">
          <p class="right_nav_title">{{ item.title }}</p>
          <div class="line"></div>
          <p class="right_navs">
            {{ item.tips }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
export default {
  mixins: [page_mx],
  data() {
    return {};
  },
  methods: {
    init() {
      this.params = this.$route.params;
      this.getAjax();
    },
    getAjax() {
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 80px;
  width: 100%;
  height: 900px;
  background: url(~@/assets/img/business/title1.png) no-repeat center;
  background-size: cover;
}
.title_text {
  width: 1176px;
  height: 90px;
  font-size: 56px;
  font-weight: 200;
  color: #ffffff;
  line-height: 90px;
  text-align-last: justify;
  text-align: justify;
  letter-spacing: 20px;
}
.g-box {
  margin-bottom: 120px;
}
.box1 {
  display: flex;
  margin-bottom: 60px;
  justify-content: space-between;
  .left_img {
    width: 420px;
    height: 280px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    transition: all 0.2s;
  }
  .left_img:hover {
    transform: scale(1.05);
  }
}

.right_nav {
  display: flex;
  flex-direction: column;
  justify-content: center;
  //overflow: hidden;
}
.right_nav_title {
  height: 45px;
  font-size: 32px;
  font-weight: 400;
  color: #000000;
  line-height: 45px;
}

.line {
  width: 60px;
  height: 2px;
  background: #0030aa;
  margin-top: 20px;
  margin-bottom: 40px;
}
.right_navs {
  width: 620px;
  font-size: 18px;
  font-weight: 400;
  color: #656878;
  line-height: 30px;
}
</style>
